import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { Table, TableKeyExtractor } from '@dreryk/react-components';

import { usePatientTableColumns, usePatientTableDataConfiguration } from './PatientTable.hooks';
import { PatientTablePlaceholder } from './PatientTablePlaceholder';

const keyExtractor: TableKeyExtractor<PatientSimple> = (patient) => patient.id;

export type PatientTableProps = {
   readonly searchText: string | null;
};

export const PatientTable = (props: PatientTableProps): JSX.Element => {
   const dataConfiguration = usePatientTableDataConfiguration(props.searchText);
   const columns = usePatientTableColumns({
      onPatientRemoved: dataConfiguration.refetch,
   });

   return (
      <Table<PatientSimple>
         testId='patients'
         columns={columns}
         dataConfiguration={dataConfiguration}
         keyExtractor={keyExtractor}
         placeholder={<PatientTablePlaceholder searchText={props.searchText} />}
      />
   );
};
